import axios from 'axios';
import { API_URL } from './baseApi';
import { IM10Payout } from '../redux/m10Payment/m10Types';

export const m10Api = {
  payout: async (payload: IM10Payout) => await axios.post(`${API_URL}/v1/m10/payout`, payload),
  getHistory: async () => await axios.get(`${API_URL}/v1/m10/history`),
  getExchangeRate: async () => await axios.get(`${API_URL}/v1/m10/exchange-rate`),
};
